import { render, staticRenderFns } from "./CurrencySelect.vue?vue&type=template&id=6a5bfbfe&scoped=true&"
import script from "./CurrencySelect.vue?vue&type=script&lang=js&"
export * from "./CurrencySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5bfbfe",
  null
  
)

export default component.exports